import { useStore } from '@'
import { $formValues } from '../stores'

export default function useFormValues(name) {
    const [values] = useStore([$formValues.subStore(name)])
    return values
}
